import React, { FC, useMemo } from 'react';
import { EasyField } from 'react-formutil';
import FieldSelect from 'components/FieldSelect';
import FormItem from 'components/FormItem';
import { useDistributionTaxYears } from 'modules/Withdraw/hooks';
import security from 'stores/security';

interface TaxYearSelectProps {
    name: string;
}

const TaxYearSelect: FC<TaxYearSelectProps> = ({ name }) => {
    const { data } = useDistributionTaxYears();

    const taxYearList = useMemo(() => {
        if (!data || !data.length) {
            return [];
        }

        return data.map(item => ({
            label: String(item),
            value: item
        }));
    }, [data]);

    if (!security.isIRAAccount) {
        return null;
    }

    if (!data || !data.length) {
        return null;
    }

    if (data.length === 1) {
        return <EasyField type="hidden" name={name} $defaultValue={data[0]} />;
    }

    return (
        <div className="space-box">
            <FormItem name={name} required label={__('Tax Year')} $defaultValue={data[0]}>
                <FieldSelect placeholder={__('Please select tax year')} data={taxYearList} />
            </FormItem>
        </div>
    );
};

export default TaxYearSelect;
